import * as types from '../constants/actionTypes';
import initialState from './initialState';

export default function pptxReducer(state = initialState.pptx, action) {

  let newState = {...state};

  switch (action.type) {
    case types.GENERATE_PPTX:
      newState.generating = true;
      return newState;
    case types.GENERATE_PPTX_SUCCESS:
      newState.generating = false;
      return newState;
    case types.GENERATE_PPTX_FAILURE:
      newState.generating = false;
      return newState;

    default:
      return newState;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/pptxReducer.js